function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//

import * as React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet, color, spacing, font } from "../../styles/theme";
var PILL_HEIGHTS = {
  sm: '1.125rem',
  md: '1.5rem',
  lg: '1.875rem'
};
export var PILL_TYPE = {
  FILLED: 'filled',
  OUTLINE: 'outline'
};
export var PILL_SIZE = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg'
};
var CONFIG = {
  pillSize: {
    sm: {
      height: PILL_HEIGHTS.sm,
      borderRadius: PILL_HEIGHTS.sm,
      lineHeight: spacing.sm,
      fontSize: font.xxs
    },
    md: {
      height: PILL_HEIGHTS.md,
      borderRadius: PILL_HEIGHTS.md,
      lineHeight: spacing.md,
      fontSize: font.xs
    },
    lg: {
      height: PILL_HEIGHTS.lg,
      borderRadius: PILL_HEIGHTS.lg,
      lineHeight: spacing.lg,
      fontSize: font.sm
    }
  },
  defaultFillColor: color.gray,
  defaultBorderColor: color.borderThemeDark
};
var styles = StyleSheet.create({
  Pill: {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    padding: "".concat(spacing.xxs, " ").concat(spacing.md),
    border: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    color: color.primaryText
  },
  centerContent: {
    display: 'flex',
    alignItems: 'center',
    margin: 'auto',
    overflow: 'hidden'
  },
  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  childContainer: {
    marginLeft: spacing.xs
  }
});
function getColorStyles(type, borderColor, fillColor) {
  switch (type) {
    case PILL_TYPE.OUTLINE:
      return {
        border: "1px solid ".concat(borderColor)
      };
    case PILL_TYPE.FILLED:
      return {
        backgroundColor: fillColor
      };
  }
}
export default function Pill(_ref) {
  var size = _ref.size,
    type = _ref.type,
    borderColor = _ref.borderColor,
    fillColor = _ref.fillColor,
    label = _ref.label,
    tag = _ref.tag,
    rootClassName = _ref.rootClassName,
    style = _ref.style,
    labelStyle = _ref.labelStyle,
    htmlAttributes = _ref.htmlAttributes,
    children = _ref.children;
  var Tag = tag;
  var sizeStyles = CONFIG.pillSize[size];
  var colorStyles = getColorStyles(type, borderColor, fillColor);
  var mergedStyles = _objectSpread(_objectSpread(_objectSpread({}, sizeStyles), colorStyles), style);
  return /*#__PURE__*/React.createElement(Tag, _extends({}, htmlAttributes, css(rootClassName, styles.Pill), {
    style: mergedStyles,
    title: label
  }), /*#__PURE__*/React.createElement("span", css(styles.centerContent), /*#__PURE__*/React.createElement("span", css(styles.ellipsis, labelStyle), label), children && /*#__PURE__*/React.createElement("span", css(styles.centerContent, styles.childContainer), children)));
}
Pill.defaultProps = {
  size: PILL_SIZE.MD,
  type: PILL_TYPE.FILLED,
  fillColor: CONFIG.defaultFillColor,
  borderColor: CONFIG.defaultBorderColor,
  tag: 'span'
};